import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import Props from './props';
import PrimaryButton from './primary-button';
import Icon, { IconName } from '../icons/icon';

export interface IconButtonProps extends Props {
  icon: IconName;
}

class IconTextButton extends React.Component<IconButtonProps, any> {
  render() {
    const { children, className, disabled, full, icon, onClick } = this.props;

    return (
      <PrimaryButton {...{ className, disabled, full, onClick }}>
        <Icon
          baseColor="inherit"
          className="icon-wrapper"
          icon={icon}
          size="md"
        />
        <div className="text">{children}</div>
      </PrimaryButton>
    );
  }
}

const StyledPrimaryButton = styled(IconTextButton)`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 1rem 1.5rem; /* Override */

  .icon-wrapper {
    margin-right: 0.5rem;
  }

  .text {
    padding-top: 0.125em;
  }
`;

export default StyledPrimaryButton;
